<template>
    <div class="logindiv">
      <div class="logo">
        <img alt="logo" src="@/assets/logo-biomedica-laboratorija.png"  height="60">
      </div>
      <div class="card p-fluid customheadercard">
				<div class="p-col-12 customheaderrow">
					<h5 class="stationsHeader">{{ translated('setpasswordheader').toUpperCase() }}</h5>
				</div>												
			</div>	
      <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
        <div v-if="(isValidEmail && isLoaded)">
            <div class="usernamediv">
            <div class="userpasspanel p-float-label p-input-icon-right">
                <i class="pi pi-envelope" />
                <InputText disabled id="email" v-model="email" aria-describedby="email-error"/>
            </div>
                        
            </div>
    
            <div class="passdiv">
    
            <div class="userpasspanel p-input-icon-right">            
                <Password id="password" v-model="password" toggleMask :feedback=false @keypress="changedInput" aria-describedby="email-error"/>
                <label :class="{'p-error': v$.password.$invalid}">{{ translated('setnewpassword') }}*</label>
            </div>
    
            </div>
            
            <div class="newpassdiv">
    
            <div class="userpasspanel  p-input-icon-right">            
                <Password id="newpassword" v-model="newpassword" toggleMask :feedback=false @keypress="changedInput" aria-describedby="email-error"/>
                <label for="newpassword" :class="{'p-error': v$.newpassword.$invalid}">{{ translated('repeatnewpassword') }}*</label>
            </div>

            </div>

            <div class="errordiv">
                <div :class="{ error: v$.password.$errors.length }">
                    
                    <div class="input-errors" v-for="error of v$.password.$errors" :key="error.$uid">
                        <div class="error-msg">{{ error.$message }}</div>
                    </div>
                </div>

                <small v-if="error && isChanged==false">{{ error }}</small>         
            </div>
            
    
            <div class="submitbutton">
                <Button :label="translated('setpass')" @click="handleSubmit(!v$.$invalid)" />                        
            </div>

        </div>
        <div class="nosessiondiv" v-if="(!isValidEmail && isLoaded)">

            <label class="erroruser">{{ translated('nosession') }}</label>            
    
            <div class="submitbutton">
                <Button :label="translated('login')" @click="handleSubmitError()" />                        
            </div>

        </div>        

  
  
      </form>
    </div>
  </template>
  
  <script>
  import { required, minLength, sameAs } from "@vuelidate/validators";
  import { useVuelidate } from "@vuelidate/core";
  import { computed, ref } from "vue";
  import store from "@/store";
  import router from "@/router";
  import createHttp from "@/services/http";
  
  export default {

    setup() {
        const isValidEmail = ref(true);
        const isLoaded = ref(false);
        const error= computed(() => store.state.error);
        const translated= computed(() => store.getters.getTranslate);
        
        return {
            isValidEmail,
            isLoaded,
            error,
            translated,
            v$: useVuelidate()
        };
    },
    data () {
        return  {            
            datareceived: true,
            cguid: '',
            uguid: '',
            email: '',
            password: '',
            newpassword: '',
            submitted: false,
            isChanged: false   
        }
    },

    validations() {
          return {
              password: { required, minLength: minLength(8) },
              newpassword: { required, sameAsPassword: sameAs(this.password) }
          }
      },    
    async mounted() {
        this.cguid = this.$route.query.cg;
        this.uguid = this.$route.query.ug;
        
        const http = createHttp(false); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/getEmail?uGuid=" + this.uguid + "&cGuid=" + this.cguid);

        if(result.status==200){
            this.email = result.data
            // console.log('OK email !!!!!!!!')
            // console.log(this.email)
            this.isValidEmail = true;
            this.isLoaded = true;
        }
        else if(result.status == 204){
            // console.log('NOOOOT OK email !!!!!!!!')
            this.isValidEmail = false;     
            this.isLoaded = true;
        }

        

    },      
      created() { 
        // console.log('ChangePassword !!!')
      },       
      methods: {
          createAccount() {
              router.push("/");
          },    
          async handleSubmitError() {
            router.push("login");
          } , 
          async handleSubmit(isFormValid) {
            this.isChanged = false
              // console.log('klicem submit:' + isFormValid)
              // console.log(this.v$.password.$invalid);
              // console.log(this.password);
              // console.log(this.newpassword);
              // console.log(this.v$);
              this.submitted = true;
  
              if (!isFormValid) {
                  return;
              }
  
              let changePasswodModel = {
                  UserGuid: this.uguid,
                  ChangePasswordGuid: this.cguid,
                  Newpassword: this.newpassword
              }
              const http = createHttp(false); 
            //// console.log(CompanyRegister);
            try {
                // console.log(process.env.VUE_APP_AUTH_FOLDER + "/setPassword");
                http.post(process.env.VUE_APP_AUTH_FOLDER + "/setPassword", changePasswodModel)
                    .then((response) => { 
                        // console.log('OK response');
                        // console.log(response);
                        router.push("login");
                    })
                    .catch((error) => {
                        const myErr = {...error};

                        // console.log('ERROR');
                        // console.log(myErr) 
                        this.Errors = myErr.response.data.Errors;
                    });
                        
                } catch (error) {
                //// console.log('ERROR TRY CATCHE!');
                //// console.log(http);
                // console.log(error);
            }
          }
      }
  }
  
  
  
  </script>
  
  <style scoped>
    .donthaveaccount {
        text-align: center;
        cursor: pointer;
    }
  
    form {
      background: white;
      padding: 20px;
      border-radius: 0 0 10px 10px;
    }
  
    form button {
      display: block;
      margin: 60px auto 0;
    }
  
    .logo img {display: block;margin-left: auto;margin-right: auto;}
  
    .logindiv .logo {
      background: #f2f2f2;
      padding:10px;
      padding-bottom: 40px;;
    }
  
  .userpasspanel {
      width: 100%;
  }
  
  .usernamediv {
      margin-top: 30px;
  }
  .p-col-12.customheaderrow {
        padding-left: 0px;
    }

  h5.stationsHeader {
        font-weight: bolder;
  }

  h5.stationsHeader {
    font-size: 1.6em;
    align-self: center;
  }
  .card.p-fluid.customheadercard {
        height: 60px;
  }
  .card.p-fluid.customheadercard {
    background: #6c757d;
    border-radius: 0 0 3px 3px;
  } 
  .p-col-12.customheaderrow {
    align-items: center;
    text-align: center;
    color: white;
    padding-top: 4px;
}
.errorplaceholder span {
        color:red;
    }

    .errorplaceholder {
        text-align: center;
    }

    label.erroruser {
    position: relative;
    font-size: 1.4em;
    color: #ab0000;
    background: #dee2e6;
    padding: 5px 20px 5px 20px;
    font-weight: bold;
}

.nosessiondiv {
    text-align: center;
}
  </style>
  